import { Component, ViewModel, ObservableArray, View } from "binder";
import { MediaSelector } from "uicomponents";
import { IPaginationInfoUpdater, PaginationInfo, PaginatorViewModel } from "../paginator/paginator-viewModel";
import { ITemplateSelector } from "../templateSelector";
import { getAsBoolean, getAsNumber } from "../utilities";
import { ColumnViewModel } from "./column/column-viewModel";
import  { ExTableView } from "./exTable-view"
import { ExtablePhoneView } from "./extablePhone/extablePhone-view";

export abstract class ExTableViewModel extends Component implements IPaginationInfoUpdater{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.showingitems = ObservableArray.create<ViewModel>();
        this.columns = ObservableArray.create<ColumnViewModel>();
        this.paginator = new PaginatorViewModel(this);
        this.paginator.paginationInfoUpdater = this;
        this.isInitializing = true;
        this.pagesize = 15;
        this.isInitializing = false;
        this.stickyheader = false;
        this.hidepages = false;
        this.shallshowfullsearch = false;
        this.internalShowColumnsList = false;
    }
    GetDefaultView(): View <ViewModel> {
        return MediaSelector.GetView({
            default : ()=>new ExTableView(),
            portraitPhone:()=>new ExtablePhoneView()
        });

        return new ExTableView();
    }
    public getTypeId(): string {
        return "VM-B7C80754-A764-4CD2-8791-188C408F7F8F"
    }
    private isInitializing : boolean;
    public set showingitems(v: ObservableArray<ViewModel>) { this._showingitems = v; } public get showingitems(): ObservableArray<ViewModel> { return this._showingitems;} private _showingitems: ObservableArray<ViewModel>;
    public set columns(v: ObservableArray<ColumnViewModel>) { this._columns = v; } public get columns(): ObservableArray<ColumnViewModel> { return this._columns;} private _columns: ObservableArray<ColumnViewModel>;
    public set paginator(v: PaginatorViewModel) { this._paginator = v; } public get paginator(): PaginatorViewModel { return this._paginator;} private _paginator: PaginatorViewModel;
    public set internalShowColumnsList(v: boolean) { this._internalShowColumnsList = v; } public get internalShowColumnsList(): boolean { return this._internalShowColumnsList;} private _internalShowColumnsList: boolean;
    public set itemTemplate(v: Node) { this._itemTemplate = v; } public get itemTemplate(): Node { return this._itemTemplate;} private _itemTemplate: Node;
    
    public set itemtemplateselector(v: ITemplateSelector) { this._itemtemplateselector = v; } public get itemtemplateselector(): ITemplateSelector { return this._itemtemplateselector;} private _itemtemplateselector: ITemplateSelector;
    public set templateselectorfunction(v: string) { this._templateselectorfunction = v; } public get templateselectorfunction(): string { return this._templateselectorfunction;} private _templateselectorfunction: string;
    public set importanthasselectorfunction(v: boolean) { this._importanthasselectorfunction = getAsBoolean(v); } public get importanthasselectorfunction(): boolean { return this._importanthasselectorfunction;} private _importanthasselectorfunction: boolean;


    public set pagesize(v: number) { 
        if(this._pagesize!=getAsNumber(v,true)){
            this._pagesize =getAsNumber(v,true); 
            this.paginator.pageSize = this._pagesize;
            if(this.isInitializing==false){
                // this.informPageChange(1,this._pagesize);
            }
        }
    } public get pagesize(): number { return this._pagesize;} private _pagesize: number;
    public set stickyheader(v: boolean) { this._stickyheader = getAsBoolean(v); } public get stickyheader(): boolean { return this._stickyheader;} private _stickyheader: boolean;
    public set hidepages(v: boolean) { this._hidepages = getAsBoolean(v); } public get hidepages(): boolean { return this._hidepages;} private _hidepages: boolean;
    public set shallshowfullsearch(v: boolean) { this._shallshowfullsearch = v; } public get shallshowfullsearch(): boolean { return this._shallshowfullsearch;} private _shallshowfullsearch: boolean;
    public set fullsearchstring(v: string) { this._fullsearchstring = v; } public get fullsearchstring(): string { return this._fullsearchstring;} private _fullsearchstring: string;
    
    abstract applyFullSearch();

    takeInColumn(column: ColumnViewModel) {
        this.columns.push(column);
        column.table = this;
    }
    columnSortChanged(column:ColumnViewModel) {
        this.columns.forEach(x=>{
            if(x!=column)
                x.setNoSort();
        });
        this.sortChanged();
    }

    abstract sortChanged();
    abstract filterChanged();
    abstract informPageChange(pageNo: number, pageSize: number): Promise<PaginationInfo>;

    onPageChanged(){
        
    }
    updatePaginationInfo(paginationInfo:PaginationInfo){
        this.paginator.updatePaginationInfo(paginationInfo.currentPage,paginationInfo.pageCount);

    }
}
